import {GetterTree} from "vuex";
import {SmsFiltersState} from "@/store/sms/filters/types";
import {RootState} from "@/store/types";

export const getters: GetterTree<SmsFiltersState, RootState> = {
  smsFilters:state => state.smsFilters,
  smsFilterItem:state => state.smsFilterItem
}